<template>
  <div class="seal-container">
    <div @click="chooseSeal" class="seal" :class="elecsealClassArr"  v-if="!isChoosed">
      <span class="sealIcon">+</span>
      <span>添加印章</span>
    </div>
    <Spin v-if="loading" fix size="small"></Spin>
    <div @click="chooseSeal" v-if="isChoosed" class="seal_choosed" :class="elecsealClassArr" :style="{
        left: posX ? posX + 'px' : 0,
        top: posY ? posY + 'px' : 0,
      }">
      <div class="move-deal" v-if="canDelete" @mousedown.stop="move($event)"></div>
      <img :src="seal.url ? seal.url : seal.sealBase64" alt="" class="sealImg" />
      <div @click.stop="deleteSeal" v-if="canDelete" v-show="showDelete" class="sealDeleteButton">
        删除
      </div>
    </div>

    <seal-list ref="sealList" :show="showList" @choose-seal="choosed" :sealConfigData="sealConfigData">
    </seal-list>

  </div>
</template>

<script>
  /* eslint-disable */
  import sealList from "./sealList.vue"
  export default {
    name: "seal",
    components: {
      "seal-list": sealList,
    },
    props: {
      sealConfigData: {
        type: [Object, null],
        default: null
      },
      nuoSeal: null
    },
    watch: {
      nuoSeal(val) { // 处理诺安数据回显的问题
        if (val) {
          const emapFlowCommentCpmponentVm = this.nuoSeal?.emapFlowCommentCpmponentVm
          if (emapFlowCommentCpmponentVm) {
            this.echoSign(emapFlowCommentCpmponentVm.chapterUrl)
          }
        }
      }
    },
    computed: {
      canDelete() {
        if (this.nuoSeal) {
          return !this.nuoSeal?.emapFlowCommentCpmponentVm?.readonly
        } else {
          return true
        }
      },
       elecsealClassArr() {
        const arr = []
        // if (this.signatureType == '1') {
        //   if(this.multiple) {
        //     if (this.chapterUrl.length === 2) {
        //       arr.push('full')
        //     }
        //     if (this.chapterUrl.length == 1) {
        //       arr.push('single')
        //     }
        //   } else {
        //     arr.push('radio')
        //     if (this.chapterUrl.length == 1) {
        //       arr.push('full')
        //     }
        //   }
        // }
      
        if (this.nuoSeal?.emapFlowCommentCpmponentVm?.readonly) {
          arr.push('readonly')
        }else {
          arr.push('full')
        } 
        return arr
      }
    },
    data: function() {
      return {
        seal: {},
        isChoosed: false,
        posX: 0,
        posY: 0,
        showDelete: false,
        showList: false, //是否打开印章列表
        // canDelete: true,
        loading: false
      }
    },

    methods: {
      // 点击添加印章
      chooseSeal: function(e) {
        if (!e || this.nuoSeal?.emapFlowCommentCpmponentVm?.readonly) return
        if (this.isChoosed) {
          this.showDelete = !this.showDelete
        } else {
          this.showList = true
        }
      },
      deleteSeal: function() {
        this.posX = 0
        this.posY = 0
        this.seal = {}
        this.showDelete = false
        this.isChoosed = false
      },
      
      echoSign(chapterUrl = []) { // 回显印章(由emap-flow-comment组件调用)
        if (chapterUrl.length > 0) { // 诺安目前有且只有一个
          const url = chapterUrl[0]
          this.seal = {
            downloadUrl: url,
            url,
            isChoosed: true,
            sealId: '',
            signid: ''
          }
          this.isChoosed = true
          this.showList = false
        }
      },

      //移动
      move: function(e) {
        var that = this
        var odiv = e.target.offsetParent //获取目标元素
        //算出鼠标相对元素的位置
        var disX = e.clientX - odiv.offsetLeft
        var disY = e.clientY - odiv.offsetTop
        console.log("offsetLeft", odiv.offsetLeft)
        document.onmousemove = function(e) {
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          var left = e.clientX - disX
          var top = e.clientY - disY
          //绑定元素位置到positionX和positionY上面
          that.posX = left
          that.posY = top
        }
        document.onmouseup = function(e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      },

      choosed: function(e) {
        if (!e || this.loading) return
        this.loading = true
        const error = this?.$Message?.error || alert
        this.nuoSeal.sign(e, (err, data) => {
          const emapFlowCommentCpmponentVm = this.nuoSeal.emapFlowCommentCpmponentVm
          this.loading = false
          if (err) {
            emapFlowCommentCpmponentVm.chapterWID = ''
            emapFlowCommentCpmponentVm.emitInput()
            return error(err?.msg || data?.msg || '添加异常')
          }
          emapFlowCommentCpmponentVm.chapterWID = data.datas.addJGSeal
          emapFlowCommentCpmponentVm.emitInput()
          this.isChoosed = true
          this.showList = false
          this.seal = e
          console.log(data)
        })
      }

    },
  }
</script>

<style>
.seal-container .ivu-spin-fix {
  background-color: rgba(255,255,255,.9) !important;
}
</style>
<style scoped>
  .seal {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 4px;
    border: 1px solid #dddee1;
  }

  .seal_choosed {
    position: absolute;
    width: 130px;
    height: 130px;
    border: 1px solid #dddee1;
    cursor: pointer;
  }
  .seal_choosed.readonly{
    cursor: not-allowed;
  }

  .seal span {
    display: block;
    text-align: center;
  }

  .seal .sealIcon {
    font-size: 38px;
    font-weight: bold;
    margin-top: 10px;
  }

  .seal_choosed .sealImg {
    width: 130px;
    height: 130px;
  }
  .seal.full{
    background-color: #f8f8f8;
    cursor: pointer;
    color: #316cf1;
  }
  .seal.full:hover {
    border: 1px solid #316cf1;
  }

  .seal.readonly {
    cursor: not-allowed;
    color: #dddee1;
  }

  .sealDeleteButton {
    position: absolute;
    bottom: -20px;
    width: 130px;
    height: 20px;
    background-color: #316cf1;
    color: #fff;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
  }

  .seal-container {
    position: relative;
  }

  /* .seal-container .move-div {
  position: absolute;
  height: 130px;
  width: 130px;
} */

  .move-div img {
    width: 130px;
    height: 130px;
  }

  .lose {
    position: absolute;
    width: 90px;
    height: 30px;
    line-height: 30px;
    top: 44px;
    left: 18px;
    font-size: 26px;
    text-align: center;
    color: gray;
    border: 5px solid;
  }
</style>
